import { Currency } from "@types";

/**
 * Currencies where we prompt players to add an email after their funding profile is
 * complete (COP/PEN PGWs require real contact data). Google-registered players already
 * have an email so they are never prompted. Configurable: add a currency to extend.
 */
export const EMAIL_COLLECTION_CURRENCIES: Currency[] = [Currency.COP, Currency.PEN];
